import CommunicationHandler from './CommunicationHandler'

export const commsHandler = new CommunicationHandler()
